exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-card[data-v-5d751550] {\n  margin-bottom: 20px;\n}\n.table-card[data-v-5d751550] {\n  margin-top: 0;\n}\n.detail-section[data-v-5d751550] {\n  margin-top: 20px;\n}\n.section-title[data-v-5d751550] {\n  font-size: 14px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #303133;\n}\n.detail-textarea[data-v-5d751550] {\n  width: 100%;\n}\n.dialog-footer[data-v-5d751550] {\n  text-align: right;\n}\n", ""]);

// exports
